import { render } from "./PublicationAnalytics.vue.js?vue&type=template&id=24462cfa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAnalytics.vue?vue&type=template&id=24462cfa"
import script from "./PublicationAnalytics.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAnalytics.vue?vue&type=script&lang=js"
export * from "./PublicationAnalytics.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24462cfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24462cfa', __exports__)) {
    api.reload('24462cfa', __exports__)
  }
  
  module.hot.accept("./PublicationAnalytics.vue.js?vue&type=template&id=24462cfa!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationAnalytics.vue?vue&type=template&id=24462cfa", () => {
    api.rerender('24462cfa', render)
  })

}


export default __exports__